import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useResizeObserver } from "@smartsheet/lodestar-utils";
import { useCallback, useState } from "react";
export var useHorizontalResize = function useHorizontalResize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$initialWidth = _ref.initialWidth,
    initialWidth = _ref$initialWidth === void 0 ? 0 : _ref$initialWidth;
  var _useState = useState(initialWidth),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useResizeObserver = useResizeObserver(useCallback(function (entry) {
      var newHorizontalSize = entry[0].borderBoxSize[0].inlineSize;
      if (newHorizontalSize) {
        setWidth(newHorizontalSize);
      }
    }, [])),
    ref = _useResizeObserver.ref;
  return {
    ref: ref,
    width: width
  };
};
//# sourceMappingURL=useHorizontalResize.js.map